import React from 'react';
import styled from 'styled-components';

import { useServerSideConstants } from 'providers/ServerSideConstantsProvider';
import { useMastheadData } from 'providers/MastheadProvider';
import { TurnkeyNavBar } from 'components/Masthead/Header';
import { MastheadVariants } from 'utils/vertical';

import S4AHeader from './S4AHeader';

interface ContainerProps {
  transparent?: boolean;
}

const Container = styled.div<ContainerProps>`
  header {
    ${props => props.transparent && 'background: transparent !important;'}
  }
`;

const Gradient = styled.div`
  position: absolute;
  width: 100%;
  height: 200px;
  z-index: -1;
  background: linear-gradient(98.85deg, rgba(18, 18, 18, 0.3) 0%, var(--background-base) 100%),
    linear-gradient(180deg, rgba(18, 18, 18, 0) 0%, var(--background-base) 100%), var(--text-bright-accent);
`;

export const Header = () => {
  const mastheadData = useMastheadData();
  const {
    verticalConfig: { features },
  } = useServerSideConstants();

  const { showHeaderGradient, configureMasthead } = features;

  const renderHeader = () => {
    if (configureMasthead?.header === MastheadVariants.S4A) {
      return <S4AHeader />;
    }

    if (mastheadData?.header) {
      return <TurnkeyNavBar data={mastheadData.header} />;
    }

    return null;
  };

  return (
    <Container transparent={showHeaderGradient}>
      {showHeaderGradient && <Gradient data-testid="header-gradient" aria-hidden="true" />}
      {renderHeader()}
    </Container>
  );
};
